import React, {Component} from 'react'
import {Volume1, Volume2, VolumeX} from "react-feather";
import styled from '@emotion/styled'
import Slider from '@material-ui/core/Slider';
import sv from "../../../../styles/styles";
import {isMobile} from 'react-device-detect';
import onClickOutside from "react-onclickoutside";
import {playerActions} from "../../../../_actions/player.actions";
import {connect} from "react-redux";

const Wrapper = styled('div')`
    ${sv.flexCenter};
    height:100%;
    .icon-hidden {
        transition: all .2s ease-out;
        stroke: ${sv.colors.light};
        opacity: .5;
    }
    .icon-shown {
        transition: all .2s ease-out;
        svg {opacity: 1;}
        opacity: 1;
    }
    .control-hidden {
        visibility: collapse;
        transition: all .2s ease-out;
        opacity: 0;
    }
    .control-shown {
        visibility: visible;
        transition: all .2s ease-out;
        svg {opacity: 1;}
        opacity: 1;
    }
`;

const IconContainer = styled('div')`
    ${sv.flexCenter};
    cursor: pointer;
    color: ${sv.colors.light};
    height: 100%;
    visibility: visible;
`;

const SliderContainer = styled('div')`
    background-color:${sv.colors.subtleGrey};
    position:absolute;
    bottom: ${isMobile ? '50px':'35px'};    // Need a little more padding on mobile to avoid fat-fingering toggle
    height: ${isMobile ? '150px':'100px'};  // Need a little more room on mobile to comfortably control
    padding: 15px 3px 15px 3px;
    border-radius: 15px;
    z-index: 1400;
`;

class VolumeControl extends Component {

    state = {
        volume: 1.0,
        volumeTracker: 1.0,
        active: false
    };

    componentWillUnmount = () => {
        this.clearVolumeSliderTimers();         // clear timers for volume viewer / hider
    }

    clearVolumeSliderTimers = () => {
        clearTimeout(this.volumeSliderViewer);  // viewer timeout
        clearTimeout(this.volumeSliderHider);   // hider timeout
    }

    onChangeVolume = (event, volume) => {
        if (this.state.active) {
            this.setState({volume});
            this.props.changeVolume(this.state.volume);
        }
    };

    onChangeVolumeCommitted = (event, volume) => {
        this.onChangeVolume(event, volume);
        this.props.dispatchVolumeChange(volume);
        this.deactivateVolumeSlider();
    };

    onMouseEnter = () => {
        this.clearVolumeSliderTimers();
        this.volumeSliderViewer = setTimeout(() => {
            this.activateVolumeSlider();
        }, 500) // 500 ms delay before activation
    };

    onMouseLeave = () => {
        this.clearVolumeSliderTimers();
        let timeout = (isMobile) ? 5000 : 2000;
        this.volumeSliderHider = setTimeout(() => {
            this.deactivateVolumeSlider();
        }, timeout)
    };

    activateVolumeSlider = () => {
        if (!this.state.active){
            this.setState({active: true});
        }
    };

    deactivateVolumeSlider = () => {
        if (this.state.active) {
            this.setState({active: false});
        }
    };

    onMuteVolumeToggle = () => {
        this.activateVolumeSlider();
        const volumeToggle = (this.state.volume === 0) ? this.state.volumeTracker : 0;
        this.setState({
            volumeTracker: (volumeToggle === 0) ? this.state.volume : this.state.volumeTracker,
            volume: volumeToggle
        });
        this.props.changeVolume(volumeToggle);
        this.props.dispatchVolumeChange(volumeToggle);
        this.deactivateVolumeSlider(5000);
    };

    handleClickOutside = () => {
        this.clearVolumeSliderTimers();
        this.deactivateVolumeSlider();
    };

    render() {
        const {volume} = this.state;
        const displayClass = this.state.active ? "-shown":"-hidden";

        let icon;
        if (volume > 0.5) {
            icon = <Volume2 size={this.props.iconSize}/>;
        } else if (volume > 0) {
            icon = <Volume1 size={this.props.iconSize}/>;
        } else {
            icon = <VolumeX size={this.props.iconSize}/>;
        }


        return (
            <Wrapper
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                <IconContainer onClick={this.onMuteVolumeToggle} className={"icon" + displayClass}>
                    {icon}
                </IconContainer>
                <SliderContainer className={"control" + displayClass}>
                    <Slider
                        orientation='vertical'
                        min={0}
                        max={1}
                        step={0.01}
                        defaultValue={1.0}
                        value={volume}
                        onChange={this.onChangeVolume}
                        onChangeCommitted={this.onChangeVolumeCommitted}
                    />
                </SliderContainer>
            </Wrapper>
        );
    }
}


function mapStateToProps() {
	return {}
}

function mapDispatchToProps(dispatch) {
	return {
		dispatchVolumeChange  : (volume)  => dispatch( playerActions.onVolumeChange(volume) ),
	}
}

const connectedVolumeControl = connect(mapStateToProps, mapDispatchToProps) (onClickOutside(VolumeControl));
export default connectedVolumeControl;